import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import config from '../../config';
import { headers } from "../../token";
import JobViews from "./JobView";
import html2pdf from 'html2pdf.js';
import ReactDOM from 'react-dom';
import vAdminformat from '../../adminFormat';
import downloadJobPDF from "./DownloadJob";
import UpdateJobs from "./JobUpdate";
import CustomDateRangePicker from "../CustomDateRangePicker";
import JobLiveUpdate from "./JobLiveUpdate";
import JobLiveView from "./JobLiveView";
import ScanPointDesk from "./ScanPointDesk";
import DeletedJob from "./DeleteJob";

/*import DeletedCustomer from "./DeleteJobs";  */


const server_backend = config.API_URL;

const JobsHistoryList = ({ username }) => {
    const [JobList, setJobList] = useState([]);
    const [isUpdating, setIsUpdating] = useState(false);
    const [filtersEnabled, setFiltersEnabled] = useState(false);
    const [filterBy, setFilterBy] = useState("job_number");
    const [filterStatus, setFilterStatus] = useState(24);
    const [filterValue, setFilterValue] = useState(null);
    const [selectedFilter, setSelectedFilter] = useState("");
    const [viewBJob, setViewBJob] = useState(false);
    const [currentJob, setCurrentJob] = useState(0);
    const [currentOrder, setCurrentOrder] = useState(0);
    const [selectedDayRange, setSelectedDayRange] = useState({
        from: '2024-02-01',
        to: '2030-02-01',
    });

    const [isPointScan, setIsPointScan] = useState(false);
    const [statusQuot, setStatusQuot] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 50;

    useEffect(() => {
        const getJobs = async () => {
            try {
                const response = await axios.get(`${server_backend}/Jobs/manual/search_delete?user_transaction=${username}&findby=${filterBy}&findfor=${filterValue}&est_id=${filterStatus}&startDate=${selectedDayRange.from}&endDate=${selectedDayRange.to}`, headers);
                if (response.data.RES_CODE === "00") {
                    setJobList(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log(error)
            }
        }
        getJobs();
    }, []);

    useEffect(() => {
        if (filtersEnabled) {
            FilterCustomer();
        }
    }, [selectedDayRange]);


    const getJobs = async () => {

        try {
            const response = await axios.get(`${server_backend}/Jobs/manual/list`, headers);

            if (response.data.RES_CODE === "00") {
                setJobList(response.data.RES_RESULT);
            }
        } catch (error) {
            console.log(error)
        }
    }


    useEffect(() => {
        const getStatusJob = async () => {
            try {
                const response = await axios.get(`${server_backend}/system/transactions/status/Job`, headers);
                if (response.data.RES_CODE === "00") {
                    //console.log(response.data);
                    setStatusQuot(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log(error);
            }
        }
        getStatusJob();
    }, []);

    const handleFiltersToggle = () => {
        setFiltersEnabled(!filtersEnabled);
    };

    const handleFilterByChange = (e) => {
        setFilterBy(e.target.value);
        const value = e.target.value;
        FilterCustomer(value);
    };

    const handleFilterStatusChange = (e) => {
        setFilterStatus(e.target.value);
    };

    const handleFilterValueChange = (e) => {
        setFilterValue(e.target.value);

        if (filtersEnabled) {
            FilterCustomer();
        }
    };

    const handleColumnClick = (filterValue) => {
        if (filtersEnabled) {
            setSelectedFilter(filterValue);
            handleFilterByChange({ target: { value: filterValue } });
        }

    };

    const FilterCustomer = async () => {

        try {
            const response = await axios.get(`${server_backend}/Jobs/search?user_transaction=${username}&findby=${filterBy}&findfor=${filterValue}&est_id=${filterStatus}&startDate=${selectedDayRange.from}&endDate=${selectedDayRange.to}`, headers);
            console.log(response.data)
            setJobList(response.data.RES_RESULT);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        if (filtersEnabled) {
            FilterCustomer();
        }
    }, [filterBy, filterStatus, filterValue]);


    const CloseViewJob = () => {
        setViewBJob(false);
    }


    const CloseModalUpdate = () => {
        setIsUpdating(false);
    }

    const CloseModalScanPoint = () => {
        setIsPointScan(false);
    }

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = JobList.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(JobList.length / itemsPerPage);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const handleDateChange = (dates) => {
        setSelectedDayRange({
            from: dates.from,
            to: dates.to,
        });
    };


    return (
        <div className="page-content" data-simplebar-track="secondary" data-simplebar="init" style={{ overflow: "auto" }}>
            {viewBJob ? (

                <JobLiveView JobID={currentJob} getJobs={getJobs} CloseViewJob={CloseViewJob} />
            ) : (
                isUpdating ? (
                    <JobLiveUpdate JobID={currentJob} getJobs={getJobs} CloseViewJob={CloseModalUpdate} />
                ) : (

                    isPointScan ? (
                        <ScanPointDesk jobID={currentOrder} getJobs={getJobs} CloseModalScanPoint={CloseModalScanPoint} />
                    ) : (

                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                        <h4 className="mb-sm-0">History</h4>
                                        <div className="page-title-right">
                                            <ol className="breadcrumb m-0">
                                                <li className="breadcrumb-item"><a href="javascript: void(0);">Jobs</a></li>
                                                <li className="breadcrumb-item active">List</li>
                                            </ol>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="card" id="tasksList">
                                        <div className="card-header bJob-0">
                                            <div className="d-flex align-items-center">
                                                <h5 className="card-title mb-0 flex-grow-1">All Jobs </h5>
                                                <div className="col-xxl-1 col-sm-2" style={{ paddingRight: "2px" }}>
                                                    <button type="button" className="btn btn-primary w-100" onClick={handleFiltersToggle}>
                                                        <i className="ri-equalizer-fill me-1 align-bottom"></i> Filters
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        {filtersEnabled && (
                                            <div className="card-body bJob bJob-dashed bJob-end-0 bJob-start-0">
                                                <div className="row g-3">
                                                    <div className="col-4">
                                                        <div className="input-light">
                                                            <select
                                                                className="form-control custom-select-style"
                                                                name="choices-single-default"
                                                                disabled={!filtersEnabled}
                                                                value={filterBy}
                                                                onChange={handleFilterByChange}
                                                            >
                                                                <option value="">Filter by</option>
                                                                <option value="job_number">ID</option>
                                                                <option value="ord_ID">Order Ref.</option>
                                                                <option value="fullname">Customer name</option>
                                                                <option value="materials_name">Material</option>
                                                            </select>

                                                        </div>
                                                    </div>
                                                    <div className="col-4">
                                                        <div className="input-light">
                                                            <select
                                                                className="form-control custom-select-style"
                                                                name="choices-single-default"
                                                                id="idFilterStatus"
                                                                disabled={!filtersEnabled}
                                                                onChange={handleFilterStatusChange}
                                                            >
                                                                <option value={0}>Filter status</option>
                                                                {statusQuot.map((status) => (
                                                                    <option key={status.est_ID} value={status.est_ID}>{status.name}</option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-4">
                                                        <CustomDateRangePicker onDateChange={handleDateChange} />
                                                    </div>
                                                    <div className="col-12">
                                                        <div className="search-box">
                                                            <input
                                                                type="text"
                                                                className="form-control search"
                                                                placeholder="Search for tasks or something..."
                                                                disabled={!filtersEnabled}
                                                                onChange={handleFilterValueChange}
                                                            />
                                                            <i className="ri-search-line search-icon"></i>
                                                        </div>
                                                    </div>

                                                </div>

                                            </div>
                                        )}

                                        <div className="card-body">
                                            <div
                                                className="table-responsive table-card mb-4"
                                                style={{ minHeight: "60vh", display: "flex", flexDirection: "column" }}
                                            >
                                                <table className="table align-middle table-nowrap mb-0" id="tasksTable">
                                                    <thead className="table-light text-muted">
                                                        <tr>
                                                            <th className="th-hover" onClick={() => handleColumnClick("job_number")}>ID</th>
                                                            <th className="th-hover" onClick={() => handleColumnClick("job_ID")}>Order Ref.</th>
                                                            <th className="th-hover" onClick={() => handleColumnClick("item_customer")}>Item & Customer</th>
                                                            <th className="th-hover" onClick={() => handleColumnClick("status")}>Status</th>
                                                            <th className="th-hover" onClick={() => handleColumnClick("materials_name")}>Material</th>
                                                            <th className="th-hover" onClick={() => handleColumnClick("date_estimated")}>Est. Completion</th>
                                                            {/* <th>Action</th> */}
                                                        </tr>
                                                    </thead>
                                                    <tbody className="list form-check-all">
                                                        {currentItems.map((Jobs_L) => (
                                                            <tr key={Jobs_L.job_number}>
                                                                <td className="id">
                                                                    <Link className="fw-medium text-black" /*onClick={() => {
                                                                        setCurrentJob(Jobs_L.job_ID);
                                                                        showViewJob();
                                                                    }} */>
                                                                        {Jobs_L.job_number}
                                                                    </Link>
                                                                </td>
                                                                <td>{Jobs_L.ord_ID}</td>
                                                                <td>
                                                                    <h6>{Jobs_L.fullname}</h6>
                                                                    <span className={`badge ${Jobs_L.isMould ? 'bg-primary' : 'bg-secondary'}`} style={{ minWidth: "68px", maxWidth: "68px" }}>
                                                                        {Jobs_L.isMould ? 'Mould' : 'Job'}
                                                                    </span>
                                                                    <p
                                                                        className="text-muted mb-0"
                                                                        data-bs-toggle="tooltip"
                                                                        data-bs-placement="top"
                                                                        title={Jobs_L.file_name}>File: {vAdminformat.truncateText(Jobs_L.file_name, 30)}</p>
                                                                    <p
                                                                        className="text-muted mb-0"
                                                                        data-bs-toggle="tooltip"
                                                                        data-bs-placement="top"
                                                                        title={Jobs_L.comment}>Description: {vAdminformat.truncateText(Jobs_L.comment, 50)}</p>

                                                                    <p
                                                                        className="text-muted mb-0"
                                                                        data-bs-toggle="tooltip"
                                                                        data-bs-placement="top"
                                                                        title={Jobs_L.file_name}>Status: {Jobs_L.status_name}</p>

                                                                </td>

                                                                <td className="status">
                                                                    <span className={`${Jobs_L.est_ID === 18 ? "badge badge-soft-warning text-uppercase"
                                                                        : Jobs_L.est_ID === 19 ? "badge badge-soft-info text-uppercase"
                                                                            : Jobs_L.est_ID === 20 ? "badge badge-soft-secondary text-uppercase"
                                                                                : Jobs_L.est_ID === 21 ? "badge badge-soft-danger text-uppercase"
                                                                                    : Jobs_L.est_ID === 22 ? "badge badge-info-success text-uppercase"
                                                                                        : Jobs_L.est_ID === 23 ? "badge badge-info-success text-uppercase"
                                                                                            : Jobs_L.est_ID === 24 ? "badge badge-soft-danger text-uppercase"
                                                                                                : "badge badge-soft-dark text-uppercase"
                                                                        }`}>
                                                                        {Jobs_L.status_name}
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <p className="text-muted mb-0">{Jobs_L.materials_name}</p>
                                                                </td>
                                                                <td className="date">{vAdminformat.FormatDate(Jobs_L.date_estimated)}</td>
                                                                {/*  <td className="due_date">
                                                                    <ul className="list-inline hstack gap-2 mb-0 fs-5">
                                                                        <li className="list-inline-item">
                                                                            <Link className="text-danger d-inline-block remove-item-btn" onClick={() => {
setCurrentJob(Jobs_L.job_ID);
                                                                                showViewJob();
                                                                            }} data-toggle="tooltip" data-placement="top" title="View">
                                                                                <i className="ri-eye-fill align-bottom me-2 text-muted"></i>
</Link>
                                                                        </li>
                                                                        <li className="list-inline-item edit">
                                                                            <Link type="button" onClick={() => {
                                                                                setCurrentJob(Jobs_L.job_ID);
ShowModalUpdate();
                                                                            }} className="text-primary d-inline-block edit-item-btn" data-toggle="tooltip" data-placement="top" title="Update">
                                                                                <i className="ri-pencil-fill fs-16"></i>
                                                                            </Link>
</li>
                                                                       
                                                                        <li className="list-inline-item edit">
                                                                            <Link type="button"
                                                                                onClick={() => {
setCurrentOrder(Jobs_L.job_ID)
                                                                                    ShowModalScanPoint()

                                                                                }
                                                                                } className="text-primary d-inline-block edit-item-btn">
<i className=" ri-qr-scan-2-line"></i>
                                                                            </Link>
                                                                        </li>
                                                                        <li className="list-inline-item" >
<Link className="text-danger d-inline-block remove-item-btn" onClick={() => {
                                                                                DeletedJob(Jobs_L.job_ID, getJobs)
                                                                            }} data-toggle="tooltip"
                                                                                data-placement="top" title="Delete">
<i className="ri-delete-bin-5-fill fs-16"></i>
                                                                            </Link>
                                                                        </li>
                                                                    </ul>
                                                                </td> */}
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>

                                            <div className="row justify-content-between align-items-center">
                                                <div className="col-auto me-3">
                                                    <p className="text-muted mb-sm-0">Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, JobList.length)} of {JobList.length} entries</p>
                                                </div>
                                                <div className="col-auto">
                                                    <ul className="pagination pagination-separated pagination-sm justify-content-end mb-sm-0">
                                                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                            <a href="#" onClick={() => handlePageChange(currentPage - 1)} className="page-link">←</a>
                                                        </li>
                                                        {Array.from({ length: totalPages }, (_, index) => (
                                                            <li key={index + 1} className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
                                                                <a href="#" onClick={() => handlePageChange(index + 1)} className="page-link">{index + 1}</a>
                                                            </li>
                                                        ))}
                                                        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                            <a href="#" onClick={() => handlePageChange(currentPage + 1)} className="page-link">→</a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className="row g-0 text-center text-sm-start">
                                                <div className="col-sm-6">
                                                </div>
                                                <div className="col-sm-6">
                                                    <div className="pagination-block pagination pagination-separated justify-content-center justify-content-sm-end mb-sm-0">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    )

                )
            )}
        </div>
    );
};

export default JobsHistoryList;
